// source: protocol_msg.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = Function('return this')();

var header_entity_pb = require('./header_entity_pb.js');
goog.object.extend(proto, header_entity_pb);
var msg_entity_pb = require('./msg_entity_pb.js');
goog.object.extend(proto, msg_entity_pb);
goog.exportSymbol('proto.himpb.BatchIMMsgReceiptAck', null, global);
goog.exportSymbol('proto.himpb.BatchIMMsgRelayRcp', null, global);
goog.exportSymbol('proto.himpb.IMMsgReceiptAck', null, global);
goog.exportSymbol('proto.himpb.IMMsgRelayNty', null, global);
goog.exportSymbol('proto.himpb.IMMsgRelayRcp', null, global);
goog.exportSymbol('proto.himpb.IMMsgRpcReq', null, global);
goog.exportSymbol('proto.himpb.IMMsgRpcRsp', null, global);
goog.exportSymbol('proto.himpb.IMMsgSendReq', null, global);
goog.exportSymbol('proto.himpb.IMMsgSendRsp', null, global);
goog.exportSymbol('proto.himpb.IMOffLineMsgsNty', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.himpb.IMMsgSendReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.himpb.IMMsgSendReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.himpb.IMMsgSendReq.displayName = 'proto.himpb.IMMsgSendReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.himpb.IMMsgSendRsp = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.himpb.IMMsgSendRsp, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.himpb.IMMsgSendRsp.displayName = 'proto.himpb.IMMsgSendRsp';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.himpb.IMMsgRelayNty = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.himpb.IMMsgRelayNty.repeatedFields_, null);
};
goog.inherits(proto.himpb.IMMsgRelayNty, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.himpb.IMMsgRelayNty.displayName = 'proto.himpb.IMMsgRelayNty';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.himpb.IMMsgRelayRcp = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.himpb.IMMsgRelayRcp, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.himpb.IMMsgRelayRcp.displayName = 'proto.himpb.IMMsgRelayRcp';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.himpb.IMMsgReceiptAck = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.himpb.IMMsgReceiptAck, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.himpb.IMMsgReceiptAck.displayName = 'proto.himpb.IMMsgReceiptAck';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.himpb.BatchIMMsgRelayRcp = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.himpb.BatchIMMsgRelayRcp.repeatedFields_, null);
};
goog.inherits(proto.himpb.BatchIMMsgRelayRcp, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.himpb.BatchIMMsgRelayRcp.displayName = 'proto.himpb.BatchIMMsgRelayRcp';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.himpb.BatchIMMsgReceiptAck = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.himpb.BatchIMMsgReceiptAck.repeatedFields_, null);
};
goog.inherits(proto.himpb.BatchIMMsgReceiptAck, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.himpb.BatchIMMsgReceiptAck.displayName = 'proto.himpb.BatchIMMsgReceiptAck';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.himpb.IMOffLineMsgsNty = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.himpb.IMOffLineMsgsNty.repeatedFields_, null);
};
goog.inherits(proto.himpb.IMOffLineMsgsNty, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.himpb.IMOffLineMsgsNty.displayName = 'proto.himpb.IMOffLineMsgsNty';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.himpb.IMMsgRpcReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.himpb.IMMsgRpcReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.himpb.IMMsgRpcReq.displayName = 'proto.himpb.IMMsgRpcReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.himpb.IMMsgRpcRsp = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.himpb.IMMsgRpcRsp, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.himpb.IMMsgRpcRsp.displayName = 'proto.himpb.IMMsgRpcRsp';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.himpb.IMMsgSendReq.prototype.toObject = function(opt_includeInstance) {
  return proto.himpb.IMMsgSendReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.himpb.IMMsgSendReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.himpb.IMMsgSendReq.toObject = function(includeInstance, msg) {
  var f, obj = {
    base: (f = msg.getBase()) && header_entity_pb.ReqBase.toObject(includeInstance, f),
    msg: (f = msg.getMsg()) && msg_entity_pb.TMsgEntity.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.himpb.IMMsgSendReq}
 */
proto.himpb.IMMsgSendReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.himpb.IMMsgSendReq;
  return proto.himpb.IMMsgSendReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.himpb.IMMsgSendReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.himpb.IMMsgSendReq}
 */
proto.himpb.IMMsgSendReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new header_entity_pb.ReqBase;
      reader.readMessage(value,header_entity_pb.ReqBase.deserializeBinaryFromReader);
      msg.setBase(value);
      break;
    case 2:
      var value = new msg_entity_pb.TMsgEntity;
      reader.readMessage(value,msg_entity_pb.TMsgEntity.deserializeBinaryFromReader);
      msg.setMsg(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.himpb.IMMsgSendReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.himpb.IMMsgSendReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.himpb.IMMsgSendReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.himpb.IMMsgSendReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getBase();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      header_entity_pb.ReqBase.serializeBinaryToWriter
    );
  }
  f = message.getMsg();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      msg_entity_pb.TMsgEntity.serializeBinaryToWriter
    );
  }
};


/**
 * optional ReqBase base = 1;
 * @return {?proto.himpb.ReqBase}
 */
proto.himpb.IMMsgSendReq.prototype.getBase = function() {
  return /** @type{?proto.himpb.ReqBase} */ (
    jspb.Message.getWrapperField(this, header_entity_pb.ReqBase, 1));
};


/**
 * @param {?proto.himpb.ReqBase|undefined} value
 * @return {!proto.himpb.IMMsgSendReq} returns this
*/
proto.himpb.IMMsgSendReq.prototype.setBase = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.himpb.IMMsgSendReq} returns this
 */
proto.himpb.IMMsgSendReq.prototype.clearBase = function() {
  return this.setBase(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.himpb.IMMsgSendReq.prototype.hasBase = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional TMsgEntity msg = 2;
 * @return {?proto.himpb.TMsgEntity}
 */
proto.himpb.IMMsgSendReq.prototype.getMsg = function() {
  return /** @type{?proto.himpb.TMsgEntity} */ (
    jspb.Message.getWrapperField(this, msg_entity_pb.TMsgEntity, 2));
};


/**
 * @param {?proto.himpb.TMsgEntity|undefined} value
 * @return {!proto.himpb.IMMsgSendReq} returns this
*/
proto.himpb.IMMsgSendReq.prototype.setMsg = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.himpb.IMMsgSendReq} returns this
 */
proto.himpb.IMMsgSendReq.prototype.clearMsg = function() {
  return this.setMsg(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.himpb.IMMsgSendReq.prototype.hasMsg = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.himpb.IMMsgSendRsp.prototype.toObject = function(opt_includeInstance) {
  return proto.himpb.IMMsgSendRsp.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.himpb.IMMsgSendRsp} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.himpb.IMMsgSendRsp.toObject = function(includeInstance, msg) {
  var f, obj = {
    base: (f = msg.getBase()) && header_entity_pb.RspBase.toObject(includeInstance, f),
    brief: (f = msg.getBrief()) && msg_entity_pb.TMsgBrief.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.himpb.IMMsgSendRsp}
 */
proto.himpb.IMMsgSendRsp.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.himpb.IMMsgSendRsp;
  return proto.himpb.IMMsgSendRsp.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.himpb.IMMsgSendRsp} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.himpb.IMMsgSendRsp}
 */
proto.himpb.IMMsgSendRsp.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new header_entity_pb.RspBase;
      reader.readMessage(value,header_entity_pb.RspBase.deserializeBinaryFromReader);
      msg.setBase(value);
      break;
    case 2:
      var value = new msg_entity_pb.TMsgBrief;
      reader.readMessage(value,msg_entity_pb.TMsgBrief.deserializeBinaryFromReader);
      msg.setBrief(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.himpb.IMMsgSendRsp.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.himpb.IMMsgSendRsp.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.himpb.IMMsgSendRsp} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.himpb.IMMsgSendRsp.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getBase();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      header_entity_pb.RspBase.serializeBinaryToWriter
    );
  }
  f = message.getBrief();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      msg_entity_pb.TMsgBrief.serializeBinaryToWriter
    );
  }
};


/**
 * optional RspBase base = 1;
 * @return {?proto.himpb.RspBase}
 */
proto.himpb.IMMsgSendRsp.prototype.getBase = function() {
  return /** @type{?proto.himpb.RspBase} */ (
    jspb.Message.getWrapperField(this, header_entity_pb.RspBase, 1));
};


/**
 * @param {?proto.himpb.RspBase|undefined} value
 * @return {!proto.himpb.IMMsgSendRsp} returns this
*/
proto.himpb.IMMsgSendRsp.prototype.setBase = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.himpb.IMMsgSendRsp} returns this
 */
proto.himpb.IMMsgSendRsp.prototype.clearBase = function() {
  return this.setBase(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.himpb.IMMsgSendRsp.prototype.hasBase = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional TMsgBrief brief = 2;
 * @return {?proto.himpb.TMsgBrief}
 */
proto.himpb.IMMsgSendRsp.prototype.getBrief = function() {
  return /** @type{?proto.himpb.TMsgBrief} */ (
    jspb.Message.getWrapperField(this, msg_entity_pb.TMsgBrief, 2));
};


/**
 * @param {?proto.himpb.TMsgBrief|undefined} value
 * @return {!proto.himpb.IMMsgSendRsp} returns this
*/
proto.himpb.IMMsgSendRsp.prototype.setBrief = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.himpb.IMMsgSendRsp} returns this
 */
proto.himpb.IMMsgSendRsp.prototype.clearBrief = function() {
  return this.setBrief(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.himpb.IMMsgSendRsp.prototype.hasBrief = function() {
  return jspb.Message.getField(this, 2) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.himpb.IMMsgRelayNty.repeatedFields_ = [15];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.himpb.IMMsgRelayNty.prototype.toObject = function(opt_includeInstance) {
  return proto.himpb.IMMsgRelayNty.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.himpb.IMMsgRelayNty} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.himpb.IMMsgRelayNty.toObject = function(includeInstance, msg) {
  var f, obj = {
    base: (f = msg.getBase()) && header_entity_pb.ReqBase.toObject(includeInstance, f),
    msg: (f = msg.getMsg()) && msg_entity_pb.TMsgEntity.toObject(includeInstance, f),
    receiversList: (f = jspb.Message.getRepeatedField(msg, 15)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.himpb.IMMsgRelayNty}
 */
proto.himpb.IMMsgRelayNty.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.himpb.IMMsgRelayNty;
  return proto.himpb.IMMsgRelayNty.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.himpb.IMMsgRelayNty} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.himpb.IMMsgRelayNty}
 */
proto.himpb.IMMsgRelayNty.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new header_entity_pb.ReqBase;
      reader.readMessage(value,header_entity_pb.ReqBase.deserializeBinaryFromReader);
      msg.setBase(value);
      break;
    case 2:
      var value = new msg_entity_pb.TMsgEntity;
      reader.readMessage(value,msg_entity_pb.TMsgEntity.deserializeBinaryFromReader);
      msg.setMsg(value);
      break;
    case 15:
      var value = /** @type {string} */ (reader.readString());
      msg.addReceivers(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.himpb.IMMsgRelayNty.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.himpb.IMMsgRelayNty.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.himpb.IMMsgRelayNty} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.himpb.IMMsgRelayNty.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getBase();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      header_entity_pb.ReqBase.serializeBinaryToWriter
    );
  }
  f = message.getMsg();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      msg_entity_pb.TMsgEntity.serializeBinaryToWriter
    );
  }
  f = message.getReceiversList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      15,
      f
    );
  }
};


/**
 * optional ReqBase base = 1;
 * @return {?proto.himpb.ReqBase}
 */
proto.himpb.IMMsgRelayNty.prototype.getBase = function() {
  return /** @type{?proto.himpb.ReqBase} */ (
    jspb.Message.getWrapperField(this, header_entity_pb.ReqBase, 1));
};


/**
 * @param {?proto.himpb.ReqBase|undefined} value
 * @return {!proto.himpb.IMMsgRelayNty} returns this
*/
proto.himpb.IMMsgRelayNty.prototype.setBase = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.himpb.IMMsgRelayNty} returns this
 */
proto.himpb.IMMsgRelayNty.prototype.clearBase = function() {
  return this.setBase(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.himpb.IMMsgRelayNty.prototype.hasBase = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional TMsgEntity msg = 2;
 * @return {?proto.himpb.TMsgEntity}
 */
proto.himpb.IMMsgRelayNty.prototype.getMsg = function() {
  return /** @type{?proto.himpb.TMsgEntity} */ (
    jspb.Message.getWrapperField(this, msg_entity_pb.TMsgEntity, 2));
};


/**
 * @param {?proto.himpb.TMsgEntity|undefined} value
 * @return {!proto.himpb.IMMsgRelayNty} returns this
*/
proto.himpb.IMMsgRelayNty.prototype.setMsg = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.himpb.IMMsgRelayNty} returns this
 */
proto.himpb.IMMsgRelayNty.prototype.clearMsg = function() {
  return this.setMsg(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.himpb.IMMsgRelayNty.prototype.hasMsg = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * repeated string receivers = 15;
 * @return {!Array<string>}
 */
proto.himpb.IMMsgRelayNty.prototype.getReceiversList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 15));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.himpb.IMMsgRelayNty} returns this
 */
proto.himpb.IMMsgRelayNty.prototype.setReceiversList = function(value) {
  return jspb.Message.setField(this, 15, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.himpb.IMMsgRelayNty} returns this
 */
proto.himpb.IMMsgRelayNty.prototype.addReceivers = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 15, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.himpb.IMMsgRelayNty} returns this
 */
proto.himpb.IMMsgRelayNty.prototype.clearReceiversList = function() {
  return this.setReceiversList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.himpb.IMMsgRelayRcp.prototype.toObject = function(opt_includeInstance) {
  return proto.himpb.IMMsgRelayRcp.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.himpb.IMMsgRelayRcp} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.himpb.IMMsgRelayRcp.toObject = function(includeInstance, msg) {
  var f, obj = {
    base: (f = msg.getBase()) && header_entity_pb.RspBase.toObject(includeInstance, f),
    brief: (f = msg.getBrief()) && msg_entity_pb.TMsgBrief.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.himpb.IMMsgRelayRcp}
 */
proto.himpb.IMMsgRelayRcp.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.himpb.IMMsgRelayRcp;
  return proto.himpb.IMMsgRelayRcp.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.himpb.IMMsgRelayRcp} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.himpb.IMMsgRelayRcp}
 */
proto.himpb.IMMsgRelayRcp.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new header_entity_pb.RspBase;
      reader.readMessage(value,header_entity_pb.RspBase.deserializeBinaryFromReader);
      msg.setBase(value);
      break;
    case 2:
      var value = new msg_entity_pb.TMsgBrief;
      reader.readMessage(value,msg_entity_pb.TMsgBrief.deserializeBinaryFromReader);
      msg.setBrief(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.himpb.IMMsgRelayRcp.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.himpb.IMMsgRelayRcp.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.himpb.IMMsgRelayRcp} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.himpb.IMMsgRelayRcp.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getBase();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      header_entity_pb.RspBase.serializeBinaryToWriter
    );
  }
  f = message.getBrief();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      msg_entity_pb.TMsgBrief.serializeBinaryToWriter
    );
  }
};


/**
 * optional RspBase base = 1;
 * @return {?proto.himpb.RspBase}
 */
proto.himpb.IMMsgRelayRcp.prototype.getBase = function() {
  return /** @type{?proto.himpb.RspBase} */ (
    jspb.Message.getWrapperField(this, header_entity_pb.RspBase, 1));
};


/**
 * @param {?proto.himpb.RspBase|undefined} value
 * @return {!proto.himpb.IMMsgRelayRcp} returns this
*/
proto.himpb.IMMsgRelayRcp.prototype.setBase = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.himpb.IMMsgRelayRcp} returns this
 */
proto.himpb.IMMsgRelayRcp.prototype.clearBase = function() {
  return this.setBase(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.himpb.IMMsgRelayRcp.prototype.hasBase = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional TMsgBrief brief = 2;
 * @return {?proto.himpb.TMsgBrief}
 */
proto.himpb.IMMsgRelayRcp.prototype.getBrief = function() {
  return /** @type{?proto.himpb.TMsgBrief} */ (
    jspb.Message.getWrapperField(this, msg_entity_pb.TMsgBrief, 2));
};


/**
 * @param {?proto.himpb.TMsgBrief|undefined} value
 * @return {!proto.himpb.IMMsgRelayRcp} returns this
*/
proto.himpb.IMMsgRelayRcp.prototype.setBrief = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.himpb.IMMsgRelayRcp} returns this
 */
proto.himpb.IMMsgRelayRcp.prototype.clearBrief = function() {
  return this.setBrief(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.himpb.IMMsgRelayRcp.prototype.hasBrief = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.himpb.IMMsgReceiptAck.prototype.toObject = function(opt_includeInstance) {
  return proto.himpb.IMMsgReceiptAck.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.himpb.IMMsgReceiptAck} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.himpb.IMMsgReceiptAck.toObject = function(includeInstance, msg) {
  var f, obj = {
    base: (f = msg.getBase()) && header_entity_pb.RspBase.toObject(includeInstance, f),
    brief: (f = msg.getBrief()) && msg_entity_pb.TMsgBrief.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.himpb.IMMsgReceiptAck}
 */
proto.himpb.IMMsgReceiptAck.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.himpb.IMMsgReceiptAck;
  return proto.himpb.IMMsgReceiptAck.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.himpb.IMMsgReceiptAck} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.himpb.IMMsgReceiptAck}
 */
proto.himpb.IMMsgReceiptAck.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new header_entity_pb.RspBase;
      reader.readMessage(value,header_entity_pb.RspBase.deserializeBinaryFromReader);
      msg.setBase(value);
      break;
    case 2:
      var value = new msg_entity_pb.TMsgBrief;
      reader.readMessage(value,msg_entity_pb.TMsgBrief.deserializeBinaryFromReader);
      msg.setBrief(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.himpb.IMMsgReceiptAck.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.himpb.IMMsgReceiptAck.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.himpb.IMMsgReceiptAck} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.himpb.IMMsgReceiptAck.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getBase();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      header_entity_pb.RspBase.serializeBinaryToWriter
    );
  }
  f = message.getBrief();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      msg_entity_pb.TMsgBrief.serializeBinaryToWriter
    );
  }
};


/**
 * optional RspBase base = 1;
 * @return {?proto.himpb.RspBase}
 */
proto.himpb.IMMsgReceiptAck.prototype.getBase = function() {
  return /** @type{?proto.himpb.RspBase} */ (
    jspb.Message.getWrapperField(this, header_entity_pb.RspBase, 1));
};


/**
 * @param {?proto.himpb.RspBase|undefined} value
 * @return {!proto.himpb.IMMsgReceiptAck} returns this
*/
proto.himpb.IMMsgReceiptAck.prototype.setBase = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.himpb.IMMsgReceiptAck} returns this
 */
proto.himpb.IMMsgReceiptAck.prototype.clearBase = function() {
  return this.setBase(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.himpb.IMMsgReceiptAck.prototype.hasBase = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional TMsgBrief brief = 2;
 * @return {?proto.himpb.TMsgBrief}
 */
proto.himpb.IMMsgReceiptAck.prototype.getBrief = function() {
  return /** @type{?proto.himpb.TMsgBrief} */ (
    jspb.Message.getWrapperField(this, msg_entity_pb.TMsgBrief, 2));
};


/**
 * @param {?proto.himpb.TMsgBrief|undefined} value
 * @return {!proto.himpb.IMMsgReceiptAck} returns this
*/
proto.himpb.IMMsgReceiptAck.prototype.setBrief = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.himpb.IMMsgReceiptAck} returns this
 */
proto.himpb.IMMsgReceiptAck.prototype.clearBrief = function() {
  return this.setBrief(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.himpb.IMMsgReceiptAck.prototype.hasBrief = function() {
  return jspb.Message.getField(this, 2) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.himpb.BatchIMMsgRelayRcp.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.himpb.BatchIMMsgRelayRcp.prototype.toObject = function(opt_includeInstance) {
  return proto.himpb.BatchIMMsgRelayRcp.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.himpb.BatchIMMsgRelayRcp} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.himpb.BatchIMMsgRelayRcp.toObject = function(includeInstance, msg) {
  var f, obj = {
    base: (f = msg.getBase()) && header_entity_pb.RspBase.toObject(includeInstance, f),
    briefList: jspb.Message.toObjectList(msg.getBriefList(),
    msg_entity_pb.TMsgBrief.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.himpb.BatchIMMsgRelayRcp}
 */
proto.himpb.BatchIMMsgRelayRcp.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.himpb.BatchIMMsgRelayRcp;
  return proto.himpb.BatchIMMsgRelayRcp.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.himpb.BatchIMMsgRelayRcp} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.himpb.BatchIMMsgRelayRcp}
 */
proto.himpb.BatchIMMsgRelayRcp.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new header_entity_pb.RspBase;
      reader.readMessage(value,header_entity_pb.RspBase.deserializeBinaryFromReader);
      msg.setBase(value);
      break;
    case 2:
      var value = new msg_entity_pb.TMsgBrief;
      reader.readMessage(value,msg_entity_pb.TMsgBrief.deserializeBinaryFromReader);
      msg.addBrief(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.himpb.BatchIMMsgRelayRcp.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.himpb.BatchIMMsgRelayRcp.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.himpb.BatchIMMsgRelayRcp} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.himpb.BatchIMMsgRelayRcp.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getBase();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      header_entity_pb.RspBase.serializeBinaryToWriter
    );
  }
  f = message.getBriefList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      msg_entity_pb.TMsgBrief.serializeBinaryToWriter
    );
  }
};


/**
 * optional RspBase base = 1;
 * @return {?proto.himpb.RspBase}
 */
proto.himpb.BatchIMMsgRelayRcp.prototype.getBase = function() {
  return /** @type{?proto.himpb.RspBase} */ (
    jspb.Message.getWrapperField(this, header_entity_pb.RspBase, 1));
};


/**
 * @param {?proto.himpb.RspBase|undefined} value
 * @return {!proto.himpb.BatchIMMsgRelayRcp} returns this
*/
proto.himpb.BatchIMMsgRelayRcp.prototype.setBase = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.himpb.BatchIMMsgRelayRcp} returns this
 */
proto.himpb.BatchIMMsgRelayRcp.prototype.clearBase = function() {
  return this.setBase(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.himpb.BatchIMMsgRelayRcp.prototype.hasBase = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * repeated TMsgBrief brief = 2;
 * @return {!Array<!proto.himpb.TMsgBrief>}
 */
proto.himpb.BatchIMMsgRelayRcp.prototype.getBriefList = function() {
  return /** @type{!Array<!proto.himpb.TMsgBrief>} */ (
    jspb.Message.getRepeatedWrapperField(this, msg_entity_pb.TMsgBrief, 2));
};


/**
 * @param {!Array<!proto.himpb.TMsgBrief>} value
 * @return {!proto.himpb.BatchIMMsgRelayRcp} returns this
*/
proto.himpb.BatchIMMsgRelayRcp.prototype.setBriefList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.himpb.TMsgBrief=} opt_value
 * @param {number=} opt_index
 * @return {!proto.himpb.TMsgBrief}
 */
proto.himpb.BatchIMMsgRelayRcp.prototype.addBrief = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.himpb.TMsgBrief, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.himpb.BatchIMMsgRelayRcp} returns this
 */
proto.himpb.BatchIMMsgRelayRcp.prototype.clearBriefList = function() {
  return this.setBriefList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.himpb.BatchIMMsgReceiptAck.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.himpb.BatchIMMsgReceiptAck.prototype.toObject = function(opt_includeInstance) {
  return proto.himpb.BatchIMMsgReceiptAck.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.himpb.BatchIMMsgReceiptAck} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.himpb.BatchIMMsgReceiptAck.toObject = function(includeInstance, msg) {
  var f, obj = {
    base: (f = msg.getBase()) && header_entity_pb.RspBase.toObject(includeInstance, f),
    briefList: jspb.Message.toObjectList(msg.getBriefList(),
    msg_entity_pb.TMsgBrief.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.himpb.BatchIMMsgReceiptAck}
 */
proto.himpb.BatchIMMsgReceiptAck.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.himpb.BatchIMMsgReceiptAck;
  return proto.himpb.BatchIMMsgReceiptAck.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.himpb.BatchIMMsgReceiptAck} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.himpb.BatchIMMsgReceiptAck}
 */
proto.himpb.BatchIMMsgReceiptAck.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new header_entity_pb.RspBase;
      reader.readMessage(value,header_entity_pb.RspBase.deserializeBinaryFromReader);
      msg.setBase(value);
      break;
    case 2:
      var value = new msg_entity_pb.TMsgBrief;
      reader.readMessage(value,msg_entity_pb.TMsgBrief.deserializeBinaryFromReader);
      msg.addBrief(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.himpb.BatchIMMsgReceiptAck.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.himpb.BatchIMMsgReceiptAck.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.himpb.BatchIMMsgReceiptAck} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.himpb.BatchIMMsgReceiptAck.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getBase();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      header_entity_pb.RspBase.serializeBinaryToWriter
    );
  }
  f = message.getBriefList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      msg_entity_pb.TMsgBrief.serializeBinaryToWriter
    );
  }
};


/**
 * optional RspBase base = 1;
 * @return {?proto.himpb.RspBase}
 */
proto.himpb.BatchIMMsgReceiptAck.prototype.getBase = function() {
  return /** @type{?proto.himpb.RspBase} */ (
    jspb.Message.getWrapperField(this, header_entity_pb.RspBase, 1));
};


/**
 * @param {?proto.himpb.RspBase|undefined} value
 * @return {!proto.himpb.BatchIMMsgReceiptAck} returns this
*/
proto.himpb.BatchIMMsgReceiptAck.prototype.setBase = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.himpb.BatchIMMsgReceiptAck} returns this
 */
proto.himpb.BatchIMMsgReceiptAck.prototype.clearBase = function() {
  return this.setBase(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.himpb.BatchIMMsgReceiptAck.prototype.hasBase = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * repeated TMsgBrief brief = 2;
 * @return {!Array<!proto.himpb.TMsgBrief>}
 */
proto.himpb.BatchIMMsgReceiptAck.prototype.getBriefList = function() {
  return /** @type{!Array<!proto.himpb.TMsgBrief>} */ (
    jspb.Message.getRepeatedWrapperField(this, msg_entity_pb.TMsgBrief, 2));
};


/**
 * @param {!Array<!proto.himpb.TMsgBrief>} value
 * @return {!proto.himpb.BatchIMMsgReceiptAck} returns this
*/
proto.himpb.BatchIMMsgReceiptAck.prototype.setBriefList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.himpb.TMsgBrief=} opt_value
 * @param {number=} opt_index
 * @return {!proto.himpb.TMsgBrief}
 */
proto.himpb.BatchIMMsgReceiptAck.prototype.addBrief = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.himpb.TMsgBrief, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.himpb.BatchIMMsgReceiptAck} returns this
 */
proto.himpb.BatchIMMsgReceiptAck.prototype.clearBriefList = function() {
  return this.setBriefList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.himpb.IMOffLineMsgsNty.repeatedFields_ = [5];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.himpb.IMOffLineMsgsNty.prototype.toObject = function(opt_includeInstance) {
  return proto.himpb.IMOffLineMsgsNty.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.himpb.IMOffLineMsgsNty} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.himpb.IMOffLineMsgsNty.toObject = function(includeInstance, msg) {
  var f, obj = {
    base: (f = msg.getBase()) && header_entity_pb.ReqBase.toObject(includeInstance, f),
    msgmode: jspb.Message.getFieldWithDefault(msg, 2, 0),
    peerid: jspb.Message.getFieldWithDefault(msg, 3, ""),
    acknum: jspb.Message.getFieldWithDefault(msg, 4, 0),
    msglistList: jspb.Message.toObjectList(msg.getMsglistList(),
    msg_entity_pb.TMsgEntity.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.himpb.IMOffLineMsgsNty}
 */
proto.himpb.IMOffLineMsgsNty.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.himpb.IMOffLineMsgsNty;
  return proto.himpb.IMOffLineMsgsNty.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.himpb.IMOffLineMsgsNty} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.himpb.IMOffLineMsgsNty}
 */
proto.himpb.IMOffLineMsgsNty.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new header_entity_pb.ReqBase;
      reader.readMessage(value,header_entity_pb.ReqBase.deserializeBinaryFromReader);
      msg.setBase(value);
      break;
    case 2:
      var value = /** @type {!proto.himpb.EMsg.MsgMode} */ (reader.readEnum());
      msg.setMsgmode(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setPeerid(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setAcknum(value);
      break;
    case 5:
      var value = new msg_entity_pb.TMsgEntity;
      reader.readMessage(value,msg_entity_pb.TMsgEntity.deserializeBinaryFromReader);
      msg.addMsglist(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.himpb.IMOffLineMsgsNty.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.himpb.IMOffLineMsgsNty.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.himpb.IMOffLineMsgsNty} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.himpb.IMOffLineMsgsNty.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getBase();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      header_entity_pb.ReqBase.serializeBinaryToWriter
    );
  }
  f = message.getMsgmode();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
  f = message.getPeerid();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getAcknum();
  if (f !== 0) {
    writer.writeInt32(
      4,
      f
    );
  }
  f = message.getMsglistList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      5,
      f,
      msg_entity_pb.TMsgEntity.serializeBinaryToWriter
    );
  }
};


/**
 * optional ReqBase base = 1;
 * @return {?proto.himpb.ReqBase}
 */
proto.himpb.IMOffLineMsgsNty.prototype.getBase = function() {
  return /** @type{?proto.himpb.ReqBase} */ (
    jspb.Message.getWrapperField(this, header_entity_pb.ReqBase, 1));
};


/**
 * @param {?proto.himpb.ReqBase|undefined} value
 * @return {!proto.himpb.IMOffLineMsgsNty} returns this
*/
proto.himpb.IMOffLineMsgsNty.prototype.setBase = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.himpb.IMOffLineMsgsNty} returns this
 */
proto.himpb.IMOffLineMsgsNty.prototype.clearBase = function() {
  return this.setBase(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.himpb.IMOffLineMsgsNty.prototype.hasBase = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional EMsg.MsgMode msgMode = 2;
 * @return {!proto.himpb.EMsg.MsgMode}
 */
proto.himpb.IMOffLineMsgsNty.prototype.getMsgmode = function() {
  return /** @type {!proto.himpb.EMsg.MsgMode} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.himpb.EMsg.MsgMode} value
 * @return {!proto.himpb.IMOffLineMsgsNty} returns this
 */
proto.himpb.IMOffLineMsgsNty.prototype.setMsgmode = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};


/**
 * optional string peerId = 3;
 * @return {string}
 */
proto.himpb.IMOffLineMsgsNty.prototype.getPeerid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.himpb.IMOffLineMsgsNty} returns this
 */
proto.himpb.IMOffLineMsgsNty.prototype.setPeerid = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional int32 ackNum = 4;
 * @return {number}
 */
proto.himpb.IMOffLineMsgsNty.prototype.getAcknum = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.himpb.IMOffLineMsgsNty} returns this
 */
proto.himpb.IMOffLineMsgsNty.prototype.setAcknum = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * repeated TMsgEntity msgList = 5;
 * @return {!Array<!proto.himpb.TMsgEntity>}
 */
proto.himpb.IMOffLineMsgsNty.prototype.getMsglistList = function() {
  return /** @type{!Array<!proto.himpb.TMsgEntity>} */ (
    jspb.Message.getRepeatedWrapperField(this, msg_entity_pb.TMsgEntity, 5));
};


/**
 * @param {!Array<!proto.himpb.TMsgEntity>} value
 * @return {!proto.himpb.IMOffLineMsgsNty} returns this
*/
proto.himpb.IMOffLineMsgsNty.prototype.setMsglistList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 5, value);
};


/**
 * @param {!proto.himpb.TMsgEntity=} opt_value
 * @param {number=} opt_index
 * @return {!proto.himpb.TMsgEntity}
 */
proto.himpb.IMOffLineMsgsNty.prototype.addMsglist = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 5, opt_value, proto.himpb.TMsgEntity, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.himpb.IMOffLineMsgsNty} returns this
 */
proto.himpb.IMOffLineMsgsNty.prototype.clearMsglistList = function() {
  return this.setMsglistList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.himpb.IMMsgRpcReq.prototype.toObject = function(opt_includeInstance) {
  return proto.himpb.IMMsgRpcReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.himpb.IMMsgRpcReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.himpb.IMMsgRpcReq.toObject = function(includeInstance, msg) {
  var f, obj = {
    base: (f = msg.getBase()) && header_entity_pb.ReqBase.toObject(includeInstance, f),
    requestid: jspb.Message.getFieldWithDefault(msg, 2, 0),
    reservedid: jspb.Message.getFieldWithDefault(msg, 3, ""),
    rpctype: jspb.Message.getFieldWithDefault(msg, 4, 0),
    encodetype: jspb.Message.getFieldWithDefault(msg, 5, 0),
    acceptenctype: jspb.Message.getFieldWithDefault(msg, 6, 0),
    param: msg.getParam_asB64(),
    microphoneclose: jspb.Message.getBooleanFieldWithDefault(msg, 8, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.himpb.IMMsgRpcReq}
 */
proto.himpb.IMMsgRpcReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.himpb.IMMsgRpcReq;
  return proto.himpb.IMMsgRpcReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.himpb.IMMsgRpcReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.himpb.IMMsgRpcReq}
 */
proto.himpb.IMMsgRpcReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new header_entity_pb.ReqBase;
      reader.readMessage(value,header_entity_pb.ReqBase.deserializeBinaryFromReader);
      msg.setBase(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setRequestid(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setReservedid(value);
      break;
    case 4:
      var value = /** @type {!proto.himpb.EMsg.RPCType} */ (reader.readEnum());
      msg.setRpctype(value);
      break;
    case 5:
      var value = /** @type {!proto.himpb.EMsg.EncodeType} */ (reader.readEnum());
      msg.setEncodetype(value);
      break;
    case 6:
      var value = /** @type {!proto.himpb.EMsg.EncodeType} */ (reader.readEnum());
      msg.setAcceptenctype(value);
      break;
    case 7:
      var value = /** @type {!Uint8Array} */ (reader.readBytes());
      msg.setParam(value);
      break;
    case 8:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setMicrophoneclose(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.himpb.IMMsgRpcReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.himpb.IMMsgRpcReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.himpb.IMMsgRpcReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.himpb.IMMsgRpcReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getBase();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      header_entity_pb.ReqBase.serializeBinaryToWriter
    );
  }
  f = message.getRequestid();
  if (f !== 0) {
    writer.writeUint32(
      2,
      f
    );
  }
  f = message.getReservedid();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getRpctype();
  if (f !== 0.0) {
    writer.writeEnum(
      4,
      f
    );
  }
  f = message.getEncodetype();
  if (f !== 0.0) {
    writer.writeEnum(
      5,
      f
    );
  }
  f = message.getAcceptenctype();
  if (f !== 0.0) {
    writer.writeEnum(
      6,
      f
    );
  }
  f = message.getParam_asU8();
  if (f.length > 0) {
    writer.writeBytes(
      7,
      f
    );
  }
  f = message.getMicrophoneclose();
  if (f) {
    writer.writeBool(
      8,
      f
    );
  }
};


/**
 * optional ReqBase base = 1;
 * @return {?proto.himpb.ReqBase}
 */
proto.himpb.IMMsgRpcReq.prototype.getBase = function() {
  return /** @type{?proto.himpb.ReqBase} */ (
    jspb.Message.getWrapperField(this, header_entity_pb.ReqBase, 1));
};


/**
 * @param {?proto.himpb.ReqBase|undefined} value
 * @return {!proto.himpb.IMMsgRpcReq} returns this
*/
proto.himpb.IMMsgRpcReq.prototype.setBase = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.himpb.IMMsgRpcReq} returns this
 */
proto.himpb.IMMsgRpcReq.prototype.clearBase = function() {
  return this.setBase(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.himpb.IMMsgRpcReq.prototype.hasBase = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional uint32 requestId = 2;
 * @return {number}
 */
proto.himpb.IMMsgRpcReq.prototype.getRequestid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.himpb.IMMsgRpcReq} returns this
 */
proto.himpb.IMMsgRpcReq.prototype.setRequestid = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional string reservedId = 3;
 * @return {string}
 */
proto.himpb.IMMsgRpcReq.prototype.getReservedid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.himpb.IMMsgRpcReq} returns this
 */
proto.himpb.IMMsgRpcReq.prototype.setReservedid = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional EMsg.RPCType rpcType = 4;
 * @return {!proto.himpb.EMsg.RPCType}
 */
proto.himpb.IMMsgRpcReq.prototype.getRpctype = function() {
  return /** @type {!proto.himpb.EMsg.RPCType} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {!proto.himpb.EMsg.RPCType} value
 * @return {!proto.himpb.IMMsgRpcReq} returns this
 */
proto.himpb.IMMsgRpcReq.prototype.setRpctype = function(value) {
  return jspb.Message.setProto3EnumField(this, 4, value);
};


/**
 * optional EMsg.EncodeType encodeType = 5;
 * @return {!proto.himpb.EMsg.EncodeType}
 */
proto.himpb.IMMsgRpcReq.prototype.getEncodetype = function() {
  return /** @type {!proto.himpb.EMsg.EncodeType} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {!proto.himpb.EMsg.EncodeType} value
 * @return {!proto.himpb.IMMsgRpcReq} returns this
 */
proto.himpb.IMMsgRpcReq.prototype.setEncodetype = function(value) {
  return jspb.Message.setProto3EnumField(this, 5, value);
};


/**
 * optional EMsg.EncodeType acceptEncType = 6;
 * @return {!proto.himpb.EMsg.EncodeType}
 */
proto.himpb.IMMsgRpcReq.prototype.getAcceptenctype = function() {
  return /** @type {!proto.himpb.EMsg.EncodeType} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {!proto.himpb.EMsg.EncodeType} value
 * @return {!proto.himpb.IMMsgRpcReq} returns this
 */
proto.himpb.IMMsgRpcReq.prototype.setAcceptenctype = function(value) {
  return jspb.Message.setProto3EnumField(this, 6, value);
};


/**
 * optional bytes param = 7;
 * @return {string}
 */
proto.himpb.IMMsgRpcReq.prototype.getParam = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * optional bytes param = 7;
 * This is a type-conversion wrapper around `getParam()`
 * @return {string}
 */
proto.himpb.IMMsgRpcReq.prototype.getParam_asB64 = function() {
  return /** @type {string} */ (jspb.Message.bytesAsB64(
      this.getParam()));
};


/**
 * optional bytes param = 7;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getParam()`
 * @return {!Uint8Array}
 */
proto.himpb.IMMsgRpcReq.prototype.getParam_asU8 = function() {
  return /** @type {!Uint8Array} */ (jspb.Message.bytesAsU8(
      this.getParam()));
};


/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto.himpb.IMMsgRpcReq} returns this
 */
proto.himpb.IMMsgRpcReq.prototype.setParam = function(value) {
  return jspb.Message.setProto3BytesField(this, 7, value);
};


/**
 * optional bool microphoneClose = 8;
 * @return {boolean}
 */
proto.himpb.IMMsgRpcReq.prototype.getMicrophoneclose = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 8, false));
};


/**
 * @param {boolean} value
 * @return {!proto.himpb.IMMsgRpcReq} returns this
 */
proto.himpb.IMMsgRpcReq.prototype.setMicrophoneclose = function(value) {
  return jspb.Message.setProto3BooleanField(this, 8, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.himpb.IMMsgRpcRsp.prototype.toObject = function(opt_includeInstance) {
  return proto.himpb.IMMsgRpcRsp.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.himpb.IMMsgRpcRsp} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.himpb.IMMsgRpcRsp.toObject = function(includeInstance, msg) {
  var f, obj = {
    base: (f = msg.getBase()) && header_entity_pb.RspBase.toObject(includeInstance, f),
    requestid: jspb.Message.getFieldWithDefault(msg, 2, 0),
    rpctype: jspb.Message.getFieldWithDefault(msg, 3, 0),
    encodetype: jspb.Message.getFieldWithDefault(msg, 4, 0),
    acknum: jspb.Message.getFieldWithDefault(msg, 5, 0),
    result: msg.getResult_asB64()
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.himpb.IMMsgRpcRsp}
 */
proto.himpb.IMMsgRpcRsp.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.himpb.IMMsgRpcRsp;
  return proto.himpb.IMMsgRpcRsp.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.himpb.IMMsgRpcRsp} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.himpb.IMMsgRpcRsp}
 */
proto.himpb.IMMsgRpcRsp.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new header_entity_pb.RspBase;
      reader.readMessage(value,header_entity_pb.RspBase.deserializeBinaryFromReader);
      msg.setBase(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setRequestid(value);
      break;
    case 3:
      var value = /** @type {!proto.himpb.EMsg.RPCType} */ (reader.readEnum());
      msg.setRpctype(value);
      break;
    case 4:
      var value = /** @type {!proto.himpb.EMsg.EncodeType} */ (reader.readEnum());
      msg.setEncodetype(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setAcknum(value);
      break;
    case 6:
      var value = /** @type {!Uint8Array} */ (reader.readBytes());
      msg.setResult(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.himpb.IMMsgRpcRsp.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.himpb.IMMsgRpcRsp.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.himpb.IMMsgRpcRsp} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.himpb.IMMsgRpcRsp.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getBase();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      header_entity_pb.RspBase.serializeBinaryToWriter
    );
  }
  f = message.getRequestid();
  if (f !== 0) {
    writer.writeUint32(
      2,
      f
    );
  }
  f = message.getRpctype();
  if (f !== 0.0) {
    writer.writeEnum(
      3,
      f
    );
  }
  f = message.getEncodetype();
  if (f !== 0.0) {
    writer.writeEnum(
      4,
      f
    );
  }
  f = message.getAcknum();
  if (f !== 0) {
    writer.writeInt32(
      5,
      f
    );
  }
  f = message.getResult_asU8();
  if (f.length > 0) {
    writer.writeBytes(
      6,
      f
    );
  }
};


/**
 * optional RspBase base = 1;
 * @return {?proto.himpb.RspBase}
 */
proto.himpb.IMMsgRpcRsp.prototype.getBase = function() {
  return /** @type{?proto.himpb.RspBase} */ (
    jspb.Message.getWrapperField(this, header_entity_pb.RspBase, 1));
};


/**
 * @param {?proto.himpb.RspBase|undefined} value
 * @return {!proto.himpb.IMMsgRpcRsp} returns this
*/
proto.himpb.IMMsgRpcRsp.prototype.setBase = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.himpb.IMMsgRpcRsp} returns this
 */
proto.himpb.IMMsgRpcRsp.prototype.clearBase = function() {
  return this.setBase(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.himpb.IMMsgRpcRsp.prototype.hasBase = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional uint32 requestId = 2;
 * @return {number}
 */
proto.himpb.IMMsgRpcRsp.prototype.getRequestid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.himpb.IMMsgRpcRsp} returns this
 */
proto.himpb.IMMsgRpcRsp.prototype.setRequestid = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional EMsg.RPCType rpcType = 3;
 * @return {!proto.himpb.EMsg.RPCType}
 */
proto.himpb.IMMsgRpcRsp.prototype.getRpctype = function() {
  return /** @type {!proto.himpb.EMsg.RPCType} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {!proto.himpb.EMsg.RPCType} value
 * @return {!proto.himpb.IMMsgRpcRsp} returns this
 */
proto.himpb.IMMsgRpcRsp.prototype.setRpctype = function(value) {
  return jspb.Message.setProto3EnumField(this, 3, value);
};


/**
 * optional EMsg.EncodeType encodeType = 4;
 * @return {!proto.himpb.EMsg.EncodeType}
 */
proto.himpb.IMMsgRpcRsp.prototype.getEncodetype = function() {
  return /** @type {!proto.himpb.EMsg.EncodeType} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {!proto.himpb.EMsg.EncodeType} value
 * @return {!proto.himpb.IMMsgRpcRsp} returns this
 */
proto.himpb.IMMsgRpcRsp.prototype.setEncodetype = function(value) {
  return jspb.Message.setProto3EnumField(this, 4, value);
};


/**
 * optional int32 ackNum = 5;
 * @return {number}
 */
proto.himpb.IMMsgRpcRsp.prototype.getAcknum = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.himpb.IMMsgRpcRsp} returns this
 */
proto.himpb.IMMsgRpcRsp.prototype.setAcknum = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional bytes result = 6;
 * @return {string}
 */
proto.himpb.IMMsgRpcRsp.prototype.getResult = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * optional bytes result = 6;
 * This is a type-conversion wrapper around `getResult()`
 * @return {string}
 */
proto.himpb.IMMsgRpcRsp.prototype.getResult_asB64 = function() {
  return /** @type {string} */ (jspb.Message.bytesAsB64(
      this.getResult()));
};


/**
 * optional bytes result = 6;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getResult()`
 * @return {!Uint8Array}
 */
proto.himpb.IMMsgRpcRsp.prototype.getResult_asU8 = function() {
  return /** @type {!Uint8Array} */ (jspb.Message.bytesAsU8(
      this.getResult()));
};


/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto.himpb.IMMsgRpcRsp} returns this
 */
proto.himpb.IMMsgRpcRsp.prototype.setResult = function(value) {
  return jspb.Message.setProto3BytesField(this, 6, value);
};


goog.object.extend(exports, proto.himpb);
